import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Typography, Alert } from "@mui/material";
import apiClient from "../../api-client";
import { CustomTextField } from "../../components/CustomTextField";
import { AuthLayout } from "../../components/AuthLayout";
import { Button } from "../../components/Button";
import { FormField } from "../../components/FormField";

export function RequestPasswordReset() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

    if (!email.trim()) {
      setError("El email es requerido");
      return;
    }
    if (!email.includes("@")) {
      setError("Por favor ingresa un email válido");
      return;
    }

    setIsLoading(true);
    try {
      await apiClient.post("users/password-reset/request/", { email });
      setSuccess(true);
    } catch {
      setError("No pudimos procesar la solicitud. Inténtalo de nuevo.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout
      kicker="Recuperar acceso"
      footer={<>¿Ya la recuerdas? <RouterLink to="/login">Vuelve a iniciar sesión</RouterLink></>}
      title="Recupera tu contraseña"
      subtitle="Introduce tu correo y te enviaremos un enlace válido durante 15 minutos con el que podrás restablecer tu contraseña."
    >
      <Box component="form" onSubmit={handleSubmit} sx={{ display: "grid", rowGap: 2 }}>
        <FormField label="Email">
          <CustomTextField
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@agencia.com"
            disabled={isLoading}
          />
        </FormField>

        {error && (
          <Alert severity="error">
            <Typography variant="body2">{error}</Typography>
          </Alert>
        )}

        {success && (
          <Alert severity="success">
            <Typography variant="body2">
              Si el correo existe, recibirás un enlace para restablecer la contraseña.
            </Typography>
          </Alert>
        )}

        <Button
          type="submit"
          size="lg"
          fullWidth
          sx={{ mt: 1 }}
          disabled={isLoading}
        >
          {isLoading ? "Enviando..." : "Enviar enlace"}
        </Button>
      </Box>
    </AuthLayout>
  );
}
